import { NgModule } from '@angular/core';
import { PasswordStrengthMeterComponent } from './password-strength-meter.component';
import { PSMProgressBarDirective } from './psm-progress-bar.directive';

@NgModule({
  imports: [PasswordStrengthMeterComponent, PSMProgressBarDirective],
  exports: [PasswordStrengthMeterComponent, PSMProgressBarDirective],
})
export class PasswordStrengthMeterModule {}
